import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export function StudentsView({ students }) {
  return (
    <section className="th-card">
      <div className="th-card-head"><h2>Students</h2><span className="th-muted">{students.length} total</span></div>
      {students.length === 0 ? <p className="th-empty">No students in this class.</p> : (
        <ul className="th-list">
          {students.map((s) => (
            <li key={s._id} className="th-row th-row-top">
              <div>
                <div className="th-row-title">{s.name}</div>
                <div className="th-muted">
                  {s.fathersName ? `S/o ${s.fathersName}` : `Class ${s.class || ''}${s.section ? ` - ${s.section}` : ''}`}
                </div>
              </div>
              {(s.guardianPhone || s.mobile)
                ? <a className="th-btn th-btn-sm th-btn-outline" href={`tel:${s.guardianPhone || s.mobile}`}>📞 {s.guardianPhone || s.mobile}</a>
                : <span className="th-muted">No phone</span>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const LABEL = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function TimetableView({ cls, user }) {
  const dow = new Date().getDay(); // 0 = Sunday
  const [day, setDay] = useState(dow === 0 ? 0 : dow - 1);
  const [tt, setTt] = useState(undefined);

  useEffect(() => {
    if (!cls) { setTt(null); return; }
    axios.get(`${API_BASE_URL}/api/timetable/${encodeURIComponent(cls)}`, { params: { userRole: 'teacher', userId: user.id } })
      .then((r) => setTt(r.data && !r.data.error ? r.data : null)).catch(() => setTt(null));
  }, [cls, user.id]);

  const slots = (tt?.schedule?.[DAYS[day]] || []).map((s, i) => {
    const subj = s?.subject ? tt.subjects?.find((x) => x.code === s.subject) : null;
    const p = tt.periods?.[i];
    return { name: p?.name || `Period ${i + 1}`, time: p ? `${p.startTime} - ${p.endTime}` : '', subject: subj?.name || s?.subject || '', teacher: subj?.teacherName || s?.teacher || '' };
  }).filter((s) => s.subject);

  return (
    <section className="th-card">
      <div className="th-card-head"><h2>Timetable{cls ? ` · Class ${cls}` : ''}</h2></div>
      <div className="th-seg">
        {LABEL.map((l, i) => <button key={l} type="button" className={day === i ? 'on' : ''} onClick={() => setDay(i)}>{l}</button>)}
      </div>
      {tt === undefined ? <p className="th-empty">Loading…</p>
        : tt === null ? <p className="th-empty">No timetable has been set for this class.</p>
        : slots.length === 0 ? <p className="th-empty">No classes on {LABEL[day]}.</p> : (
          <ul className="th-list">
            {slots.map((s, i) => (
              <li key={i} className="th-row th-row-top">
                <div>
                  <div className="th-row-title">{s.name}: {s.subject}</div>
                  {s.teacher && <div className="th-muted">{s.teacher}</div>}
                </div>
                <span className="th-muted">{s.time}</span>
              </li>
            ))}
          </ul>
        )}
    </section>
  );
}
